"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithTopicFeature = void 0;
var TopicRepository_1 = require("./TopicRepository");
var TopicTypes_1 = require("./TopicTypes");
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function WithTopicFeature(Base) {
    return /** @class */ (function (_super) {
        __extends(TopicFeature, _super);
        function TopicFeature() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _this = _super.apply(this, __spreadArray([], __read(args), false)) || this;
            _this.topics = new TopicRepository_1.TopicRepository();
            _this.inBroadcast = function (_a) {
                var _b = __read(_a, 3), topic = _b[0], body = _b[1], sender = _b[2];
                if (_this.topics.has(topic)) {
                    var client = _this.createRef(sender);
                    _this.router.emit('topicBroadcast', [topic, body, client]);
                }
            };
            _this.inUpdate = function (_a) {
                var _b = __read(_a, 3), topic = _b[0], update = _b[1], sender = _b[2];
                if (_this.topics.has(topic)) {
                    var data = _this.topics.reset(topic, update);
                    // If sender is not sent, it's a reply so the sender is us (kinda)
                    var client = sender ? _this.createRef(sender) : _this.getThisClient();
                    _this.router.emit('topicUpdate', [topic, data, client]);
                }
            };
            _this.pod.receive('broadcast_topic', _this.inBroadcast);
            _this.pod.receive('notify_topic', _this.inUpdate);
            return _this;
        }
        TopicFeature.prototype.hasTopicSubscription = function (topic) {
            return this.topics.has(topic);
        };
        TopicFeature.prototype.getTopicData = function (topic) {
            return this.topics.get(topic);
        };
        TopicFeature.prototype.subscribeTopic = function (topic) {
            if (this.readonly || this.destroyed())
                return;
            // We can call subscribeTopic to refresh to local version so don't crash if we already have the topic in the repo
            if (!this.topics.has(topic)) {
                this.topics.add(topic);
            }
            this.pod.send('subscribe_topic', [topic]);
        };
        TopicFeature.prototype.forgetTopic = function (topic) {
            if (this.readonly || this.destroyed())
                return;
            // Be gentle
            if (!this.topics.has(topic))
                return;
            var data = this.topics.delete(topic);
            this.router.emit('topicForgotten', [topic, data]);
            this.pod.send('forget_topic', [topic]);
        };
        TopicFeature.prototype.broadcastTopic = function (topic, data) {
            this.pod.send('broadcast_topic', [topic, data]);
        };
        TopicFeature.prototype.resetTopic = function (topic, data) {
            var current = this.getTopicData(topic);
            if (this.readonly || this.destroyed())
                return current;
            // Clean data of invalid entries
            data = TopicTypes_1.TopicValues.clean(data);
            // Submit patch
            this.pod.send('reset_topic', [topic, data]);
            // Patch locally and return new version
            return this.topics.reset(topic, data);
        };
        TopicFeature.prototype.patchTopic = function (topic, values) {
            var current = this.getTopicData(topic);
            if (this.readonly || this.destroyed())
                return current;
            // Clean values of invalid entries
            values = TopicTypes_1.TopicValues.clean(values);
            // Submit patch
            var reductionKey = Object.keys(values).sort().join('/');
            this.pod.send('patch_topic', [topic, values], reductionKey);
            // Patch locally and return new version
            return this.topics.patch(topic, values);
        };
        TopicFeature.prototype.on = function (type, to) {
            return this.router.on(type, to);
        };
        return TopicFeature;
    }(Base));
}
exports.WithTopicFeature = WithTopicFeature;
